import { render, staticRenderFns } from "./FacilityTypeModal.vue?vue&type=template&id=6061ca5d&scoped=true&"
import script from "./FacilityTypeModal.vue?vue&type=script&lang=js&"
export * from "./FacilityTypeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6061ca5d",
  null
  
)

export default component.exports